import { helloStarter } from '$utils/log';

// Starter example. Check the comments!
document.addEventListener('DOMContentLoaded', () => {
  const name = 'John Doe';
  helloStarter(name);
});
